import { render, staticRenderFns } from "./RestablecerContrasena.vue?vue&type=template&id=106cd87c"
import script from "./RestablecerContrasena.vue?vue&type=script&lang=js"
export * from "./RestablecerContrasena.vue?vue&type=script&lang=js"
import style0 from "./RestablecerContrasena.vue?vue&type=style&index=0&id=106cd87c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports